import React from 'react';
import withIcon from '../utilities/withIcon';

const IconMoreAndroid = () => {
  return (
    <g>
      <circle cx="8" cy="1.9236" r="1.8436" />
      <circle cx="8" cy="8" r="1.8436" />
      <circle cx="8" cy="14.0764" r="1.8436" />
    </g>
  );
};

export default withIcon(IconMoreAndroid);
